import { render, staticRenderFns } from "./WorkMethodDialog.vue?vue&type=template&id=f0fa8c5a"
import script from "./WorkMethodDialog.vue?vue&type=script&lang=js"
export * from "./WorkMethodDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports